import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { DeviationResourceType } from '../../../types/deviation';
var ViewVariant = function (_a) {
    var tier = _a.tier, className = _a.className, _b = _a.size, size = _b === void 0 ? 'medium' : _b;
    var t = useTranslation().t;
    return (React.createElement(GhostButton, { className: className, size: size, variant: "main", href: Url.userSubscriptionsPath({
            username: tier.author.username,
            tierDeviationId: tier.deviationId,
            tierContentType: 'deviations',
        }), biData: {
            evid: BiEventType.TIER_VIEW_BUTTON,
            typeid: DeviationResourceType.TIER,
            itemid: tier.deviationId,
        } }, t('deviation.tier.viewSubscription')));
};
ViewVariant.displayName = 'ViewVariant';
export default ViewVariant;
//# sourceMappingURL=View.js.map